var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-landing-layout"},[_c('nav-build',{attrs:{"isBasePage":""}}),_c('transition',{attrs:{"name":"","mode":"out-in"}},[_c('div',{staticClass:"content-block"},[_c('router-view')],1)]),[_c('footer-build')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }